module.exports = __webpack_public_path__ + "img/logo_img.5132f705.png";